import { ResponseGetCategories, RouteGetCategories } from "@CommonApi/categories";
import { useEffect, useState } from "react";
import { useApi } from "src/api";
import { useLoaders } from "src/components/InlineLoader";
import { useModals } from "src/components/Modals";
import { Button, Flex, Modal, Select } from "src/elements";
import { useAsyncState } from "src/hooks/useAsyncState";
import { pages } from "src/utils";
import { useNavigation } from "src/utils/navigation";

export const ModalImagineShelvesCategory = () => {
  const { getCategoriesApi } = useApi();
  const { hasLoader } = useLoaders();
  const { closeModal } = useModals();
  const { navigate } = useNavigation();

  const [allCategories, setAllCategories] = useAsyncState<ResponseGetCategories>();
  const [categoryCode, setCategoryCode] = useState<string | null>(null);
  const [subcategoryId, setSubcategoryId] = useState<number | null>(null);

  const isCategoriesLoading = allCategories === undefined || hasLoader(RouteGetCategories);

  const loadCategories = async () => {
    const response = await getCategoriesApi();

    if (response) {
      setAllCategories(response);
      setCategoryCode(response[0]?.categoryGroup || null);
      setSubcategoryId(response[0]?.categories[0]?.id || null);
    }
  };

  const navigateToImagineShelves = () => {
    if (subcategoryId) {
      navigate(pages.imagineShelvesCategories_categoryId_, { categoryId: subcategoryId });
      closeModal("ModalImagineShelvesCategory");
    }
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <Modal name="ModalImagineShelvesCategory" width="min-content" title="Imagine Shelves">
      <Flex column padding="20px" gap="20px">
        <Flex justify="center" gap="20px">
          <Select
            title="Category"
            isLoading={isCategoriesLoading}
            isRequired
            width="180px"
            options={
              allCategories?.map((category) => ({
                label: category.categoryGroup,
                value: category.categoryGroup,
              })) || []
            }
            value={categoryCode}
            setValue={(categoryCode) => {
              setCategoryCode(categoryCode);
              setSubcategoryId(
                allCategories?.find(
                  (categoryToCheck) => categoryToCheck.categoryGroup === categoryCode,
                )?.categories[0]?.id || null,
              );
            }}
          />

          <Select
            title="Subcategory"
            isLoading={isCategoriesLoading}
            isRequired
            width="180px"
            options={
              allCategories?.reduce<{ label: string; value: number }[]>(
                (previousSubcategories, currentCategory) => {
                  return [
                    ...previousSubcategories,
                    ...currentCategory.categories.map((currentSubcategory) => ({
                      label: currentSubcategory.code,
                      value: currentSubcategory.id,
                    })),
                  ];
                },
                [],
              ) || []
            }
            value={subcategoryId}
            setValue={(subcategoryId) => {
              setSubcategoryId(subcategoryId);
              setCategoryCode(
                allCategories?.find((oneCategory) =>
                  oneCategory.categories.some((subcategory) => subcategory.id === subcategoryId),
                )?.categoryGroup || null,
              );
            }}
          />
        </Flex>

        <Flex justify="right">
          <Button
            isDisabled={categoryCode === null || subcategoryId === null}
            onClick={navigateToImagineShelves}
          >
            Next
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
